import { Component, OnInit } from '@angular/core';
import { Store, select } from '@ngrx/store';
import { filter, from, mergeMap, of, tap, map, find, take } from 'rxjs';
import { AppState } from 'src/app/app.reducer';
import { UsuarioRedux } from 'src/app/models/usuario.model';
import { Rol } from 'src/app/modulos/admin/models/rol';
import { Ambiente } from 'src/app/modulos/catalogos-proces/models/ambiente';
import { ConstantsCatalogosIdService } from 'src/app/services/constants-catalogos-id.service';


@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.css'],
})
export class SidebarComponent implements OnInit {
nivelAplicacion:number = 0;
nivelN5:number = 0;

  constructor(
    private store: Store<AppState>
    ) {}



  //almacena la suscripción del Usuario Actual
  currentUser: UsuarioRedux = null;
  //almacena la suscripción del Ambiente Seleccionado
  ambienteSeleccionado: Ambiente = null;
  //almacena el rol actual, relacionado con el Ambiente Seleccionado
  rolActivo: Rol = null;
  nivelActivo: any = null;
  //almacena el array de nuevos menús a mostrarse en el sidebar
  nuevoMenu: any[] = [];

  /**
   *
   * * this.menus - tiene tres niveles de profundidad para construir el menú...
   * @param render: True/False permite activar o desactivar la renderización de la ruta
   * @param app: String que determina a qué aplicación pertenece ese enlace
   *
   */
  menus:any[] = [];
  menus1_4:any[] = [
    {
      label: 'Tablero',
      items: [
        {
          label: 'Escritorio',
          icon: 'fe-airplay',
          routerLink: ['/dashboard'],
          render: false,
          items: []
        },
      ],
      render: false,
    },

    {
      label: 'Administración sistema',
      items: [
        {
          label: 'Catálogos Sistemas',
          name: 'cat',
          icon: 'fe-book-open',
          routerLink: ['#'],
          items: [
            { label: 'Subsistemas',routerLink: 'subsistemas', render: false, app: ConstantsCatalogosIdService.SUBSISTEMAS},
            { label: 'Aplicaciones', routerLink: 'aplicaciones', render: false , app: ConstantsCatalogosIdService.APLICACIONES },
            { label: 'Permisos', routerLink: 'permisos', render: false , app: ConstantsCatalogosIdService.PERMISOS },
            { label: 'Roles', routerLink: ['roles'], render: false , app: ConstantsCatalogosIdService.ROLES },
          ],
          render: false
        },
        {
          label: 'Catálogos Proceso',
          name: 'lin2',
          icon: 'fe-book-open',
          routerLink: ['#'],
          items: [
            { label: 'Comunes', routerLink: 'comunes', render: false , app: ConstantsCatalogosIdService.CATALOGO_COMUN },
            { label: 'Especial uno', routerLink: 'especialuno', render: false, app: ConstantsCatalogosIdService.CATALOGO_ESPECIAL_UNO },
            { label: 'Especial dos', routerLink: 'especialdos', render: false, app: ConstantsCatalogosIdService.CATALOGO_ESPECIAL_DOS },
          ],
          render: false
        },
        {
          label: 'Reportes Planes',
          name: 'lin3',
          icon: 'fe-book-open',
          routerLink: ['#'],
          items: [
           { label: 'Reporte Plan Anuales', routerLink: ['reportePlan'], render: false , app: ConstantsCatalogosIdService.REPORTE_PLANES},
          ],
          render: false
        },
        {
          label: 'Administración',
          name: 'cat1',
          icon: 'fe-sliders',
          routerLink: ['#'],
          items: [
            { label: 'Roles-aplicaciones', routerLink: 'rol-app', render: false , app: ConstantsCatalogosIdService.ROLES_APLICACIONES },
            {label: 'Ambientes', routerLink: ['ambientes'], render: false, app: ConstantsCatalogosIdService.AMBIENTES },
            {label: 'Usuarios', routerLink: 'usuarios', render: false , app: ConstantsCatalogosIdService.USUARIOS},
            {label: 'Permisos/niveles/elementos', routerLink: 'permisos-niveles-elementos', render: false , app: ConstantsCatalogosIdService.ELEMENTOS_NIVELES_PERMISOS},
            //{label: 'Observador', routerLink: 'observador', app: ConstantsCatalogosIdService.ELEMENTOS_NIVELES_PERMISOS },
          ],
          render: false
        },
      ],
      render: false
    },

    {
      label: 'Administración procesos',
      items: [

        {
          label: 'Gestión planes', name: 'lin8', icon: 'fe-globe', routerLink: ['#'], items: [
            { label: 'Plan institucional', routerLink: ['plan-institucional'],render: false , app: ConstantsCatalogosIdService.PLAN_INSTITUCIONAL },
            { label: 'Gestión plan-años', routerLink: 'plan-anios', render: false , app: ConstantsCatalogosIdService.PLAN_ANIOS},
            { label: 'Años', routerLink: 'anios', render: false , app: ConstantsCatalogosIdService.ANIOS},
            { label: 'Participantes de los Elementos', routerLink: ['equipo-gerencial'], render: false , app: ConstantsCatalogosIdService.PARTICIPANTES_ELEMENTOS},
            { label: 'Gestión Areas', routerLink: ['areas'], render: false , app: ConstantsCatalogosIdService.AREAS},
          ],
          render: false
        },
      ]
      , render: false
    },
    {
      label: 'Formulación Planes',
      items: [
        {
          label: 'Elementos',
          name: 'lin4',
          icon: 'fe-briefcase',
          routerLink: ['#'],
          items: [
            { label: 'Visión - Misión', routerLink: 'vision', render: false , app: ConstantsCatalogosIdService.VISION_MISION },
            { label: 'Competencias/Atribuciones', routerLink: 'atribucion', render: false , app: ConstantsCatalogosIdService.COMPETENCIAS_ATRIBUCIONES},
            { label: 'Objetivos/Estrategias', routerLink: 'objetivos', render: false , app: ConstantsCatalogosIdService.OBJETIVOS_ESTRATEGIAS},
            { label: 'Lineas acción', routerLink: 'linea-accion', render: false , app: ConstantsCatalogosIdService.LINEAS_ACCION, nivelN5: 7},
            { label: 'Planes acción', routerLink: 'plan-accion', render: false , app: ConstantsCatalogosIdService.PLANES_ACCION},
            { label: 'Proyectos', routerLink: 'proyectos', render: false , app: ConstantsCatalogosIdService.PROYECTOS},
            { label: 'Procesos', routerLink: 'procesos', render: false , app: ConstantsCatalogosIdService.PROCESOS},
            { label: 'Indicadores', routerLink: 'indicadores', render: false , app: ConstantsCatalogosIdService.INDICADORES},
            { label: 'Riesgos', routerLink: 'riesgos', render: false , app: ConstantsCatalogosIdService.RIESGOS},
            {
              label: 'Servicios informativos',
              routerLink: 'servicios', render: false, app: ''
            },
          ]

          , render: false
        },
      ]
      , render: false
    },    
  ]


  menusN5:any[] = [
    {
      label: 'Tablero',
      items: [
        {
          label: 'Escritorio',
          icon: 'fe-airplay',
          routerLink: ['dashboard'],
          render: false,
          items: []
        },
      ],
      render: false,
    },

    {
      label: 'Administración sistema',
      items: [
        {
          label: 'Catálogos Sistemas',
          name: 'cat',
          icon: 'fe-book-open',
          routerLink: ['#'],
          items: [
            { label: 'Subsistemas',routerLink: 'subsistemas', render: false, app: ConstantsCatalogosIdService.SUBSISTEMAS},
            { label: 'Aplicaciones', routerLink: 'aplicaciones', render: false , app: ConstantsCatalogosIdService.APLICACIONES },
            { label: 'Permisos', routerLink: 'permisos', render: false , app: ConstantsCatalogosIdService.PERMISOS },
            { label: 'Roles', routerLink: ['roles'], render: false , app: ConstantsCatalogosIdService.ROLES },
          ],
          render: false
        },
        {
          label: 'Catálogos Proceso',
          name: 'lin2',
          icon: 'fe-book-open',
          routerLink: ['#'],
          items: [
            { label: 'Comunes', routerLink: 'comunes', render: false , app: ConstantsCatalogosIdService.CATALOGO_COMUN },
            { label: 'Especial uno', routerLink: 'especialuno', render: false, app: ConstantsCatalogosIdService.CATALOGO_ESPECIAL_UNO },
            { label: 'Especial dos', routerLink: 'especialdos', render: false, app: ConstantsCatalogosIdService.CATALOGO_ESPECIAL_DOS },
            //{ label: 'Umbrales', routerLink: ['umbrales'], render: false , app: ConstantsCatalogosIdService.CATALOGOS},
          ],
          render: false
        },
        {
          label: 'Administración',
          name: 'cat1',
          icon: 'fe-sliders',
          routerLink: ['#'],
          items: [
            { label: 'Roles-aplicaciones', routerLink: 'rol-app', render: false , app: ConstantsCatalogosIdService.ROLES_APLICACIONES },
            {label: 'Ambientes', routerLink: ['ambientes'], render: false, app: ConstantsCatalogosIdService.AMBIENTES },
            { label: 'Usuarios', routerLink: 'usuarios', render: false, app: ConstantsCatalogosIdService.USUARIOS },
             {label: 'Permisos/niveles/elementos', routerLink: 'permisos-niveles-elementos', render: false , app: ConstantsCatalogosIdService.ELEMENTOS_NIVELES_PERMISOS},
          ],
          render: false
        },
      ],
      render: false
    },

    {
      label: 'Administración procesos',
      items: [

        {
          label: 'Gestión planes', name: 'lin8', icon: 'fe-book-open', routerLink: ['#'], items: [
            { label: 'Plan institucional', routerLink: ['plan-institucional'],render: false , app: ConstantsCatalogosIdService.PLAN_INSTITUCIONAL },
            { label: 'Gestión plan-años', routerLink: 'plan-anios', render: false , app: ConstantsCatalogosIdService.PLAN_ANIOS},
            { label: 'Años', routerLink: 'anios', render: false , app: ConstantsCatalogosIdService.ANIOS},
            { label: 'Participantes de los Elementos', routerLink: ['equipo-gerencial'], render: false , app: ConstantsCatalogosIdService.PARTICIPANTES_ELEMENTOS},
            { label: 'Gestión Areas', routerLink: ['areas'], render: false , app: ConstantsCatalogosIdService.AREAS},
          ],
          render: false
        },
      ]
      , render: false
    },
    {
      label: 'Formulación Planes',
      items: [
        {
          label: 'Elementos',
          name: 'lin4',
          icon: 'fe-briefcase',
          routerLink: ['#'],
          items: [
            { label: 'Visión - Misión', routerLink: 'vision', render: false , app: ConstantsCatalogosIdService.VISION_MISION },
            { label: 'Competencias/Atribuciones', routerLink: 'atribucion', render: false , app: ConstantsCatalogosIdService.COMPETENCIAS_ATRIBUCIONES},
            { label: 'Objetivos/Estrategias', routerLink: 'objetivos', render: false , app: ConstantsCatalogosIdService.OBJETIVOS_ESTRATEGIAS},

            { label: 'Planes acción', routerLink: 'plan-accion', render: false , app: ConstantsCatalogosIdService.PLANES_ACCION},

            { label: 'Proyectos', routerLink: 'proyectos', render: false , app: ConstantsCatalogosIdService.PROYECTOS},
            { label: 'Procesos', routerLink: 'procesos', render: false , app: ConstantsCatalogosIdService.PROCESOS},
            { label: 'Indicadores', routerLink: 'indicadores', render: false , app: ConstantsCatalogosIdService.INDICADORES},
            { label: 'Riesgos', routerLink: 'riesgos', render: false , app: ConstantsCatalogosIdService.RIESGOS},
            {
              label: 'Servicios informativos',
              routerLink: 'servicios', render: false, app: ''
            },
          ]

          , render: false
        },
      ]
      , render: false
    },
  ]

  ngOnInit(): void {

    this.nivelN5 = ConstantsCatalogosIdService.ID_COMUNES_NIVEL_5;
    this.store.select("usuarioApp").subscribe((resp) => {
      this.currentUser = resp.currentUser
    })



    this.store.select("globalApp").subscribe((response)=>{// redux

    });

    // Suscripción que creará el nuevo menú dependiendo del ambiente seleccionado en el Storage NGRX
    this.store.select("globalApp").subscribe((resp) => {
      this.ambienteSeleccionado = resp.ambienteSeleccionado

      if(this.currentUser && this.ambienteSeleccionado){
        this.nivelAplicacion = resp.ambienteSeleccionado.nivel.idSprNivel;
        this.rolActivo = resp.rolSeleccionado;
        this.construirNuevoMenu()
      }
    })
  }

  /**
   * *Método para activar atributo Render del menú a True o False en los niveles 1 y 2 (Rutas padres).
   * @param items array de rutas para verificar si el parametro Render es True
   * @returns
   */
  tieneRutasHijasActivas(items: any[]): boolean {
    for (let item of items) {
      if (item.render) {
        return true
      }
    }
    return false
  }

  /**
   ** Método que permite validar con True o False si una aplicación es parte de un rol de usuario
   * @param app recibe el nombre de la aplicación para verificar si consta en la lista de aplicaciones activas para el rol designado
   * @param nivelN5
   * @returns
   */


  buscarAplicacion(app:number, nivelN5: number):boolean{
    let aplicacionesUsuario = this.rolActivo.aplicaciones;
    if(aplicacionesUsuario){
      if(aplicacionesUsuario.find(({idSprAplicacion})=>idSprAplicacion===app)){
        return true;
        }
      }else{
        return false;
      }

    return false
  }



  /**
   * * construirNuevoMenu(), crea un un observable del objeto array this.menus
   * (1) Mapea los objetos desde el nivel 3 para verificar si los enlaces de la aplicación constan en la lista de aplicaciones autorizadas por el rol de usuario
   * (2) Mapea los niveles 1 y 2 del menú para renderizar (True o False) dependiendo si hay rutas activas en el nivel 3
   * (3) Suscripción para agregar la variable nuevoMenu los enlaces renderizados -> NOTA: se hace push por cuanto los objetos se mapean por niveles
   */
  construirNuevoMenu():void{
    if (this.nivelN5 == this.nivelAplicacion){
      // Si nivel actual es N5 dibujara el menu sin planes de accion
      this.menus = this.menusN5;
    }else{
      this.menus = this.menus1_4;
    }
    this.nuevoMenu =[];
    from(this.menus).pipe(
      map((menu) => ({  //(1)
        ...menu,
        items: menu.items.map(iteml2 => ({
          ...iteml2,
          items: iteml2.items.map(iteml3 => ({
            ...iteml3,
            render: this.buscarAplicacion(iteml3.app, iteml3.nivelN5)
          })),
        })),
      })),
      map((menu) => ({   //(2)
        ...menu,
        items: menu.items.map(iteml2 => ({
          ...iteml2,
          render: this.tieneRutasHijasActivas(iteml2.items) ? true : false
        })),
        render: this.tieneRutasHijasActivas(menu.items) ? true : false
      })),
    ).subscribe((data) => { //(3)
      this.nuevoMenu.push(data);
    })
  }
}
